import { Checkbox } from '@finn-no/troika-react-checkbox';

import { thousandSeparated } from 'shared/util/formatting';

const MAX_HOTELS_IN_MAP = 2000;

interface Props {
    checkInDate?: Date | number;
    checkOutDate?: Date | number;
    numberOfHotels: number;
    displayPrices: boolean;
    setDisplayPrices: (value: boolean) => void;
    className?: string;
}

export const MapLegend = ({ checkInDate, checkOutDate, numberOfHotels, displayPrices, setDisplayPrices, className = '' }: Props) =>
    numberOfHotels > MAX_HOTELS_IN_MAP || (checkInDate && checkOutDate) ? (
        <div className="mapboxgl-ctrl-bottom-right">
            <div className={`mapboxgl-ctrl u-bg-milk u-pa8 u-border-radius-4px box-shadow map-legend ${className}`}>
                {checkInDate && checkOutDate && (
                    <Checkbox label="Vis priser" checked={displayPrices} name="Vis/" onChange={(e) => setDisplayPrices(e.target.checked)} />
                )}
                {numberOfHotels > MAX_HOTELS_IN_MAP && (
                    <div className="u-d1">
                        Vi kan maks vise {thousandSeparated(MAX_HOTELS_IN_MAP)} hoteller i kartet av gangen. Endre søkeområde eller benytt
                        filtere for å få frem flere hoteller som passer dine ønsker.
                    </div>
                )}
            </div>
        </div>
    ) : null;
